/**
 * <s-ship-date> — shows the expected dispatch date, a set number of days from today.
 *
 * Liquid renders a server-side date as the fallback; this refreshes it in the shopper's
 * own clock so cached pages never show a stale date.
 *
 * Attributes:
 *   data-days     — days to add to today (default 2)
 *   data-earliest — optional ISO date (YYYY-MM-DD) the date can never be before, e.g. a pre-order start
 */
class SShipDate extends HTMLElement {
  connectedCallback() {
    const days = Number.parseInt(this.dataset.days || '2', 10);
    let date = new Date();
    date.setDate(date.getDate() + (Number.isFinite(days) ? days : 2));

    if (this.dataset.earliest) {
      const earliest = new Date(`${this.dataset.earliest}T00:00:00`);
      if (!Number.isNaN(earliest.getTime()) && earliest > date) date = earliest;
    }

    const locale = document.documentElement.lang || 'en-AU';
    const weekday = date.toLocaleDateString(locale, { weekday: 'short' });
    const month = date.toLocaleDateString(locale, { month: 'short' });
    this.textContent = `${weekday}, ${month} ${date.getDate()}`;
  }
}

if (!customElements.get('s-ship-date')) {
  customElements.define('s-ship-date', SShipDate);
}
